<main>
  <div class="container-box basepadding">

    <div *ngIf="showError" class="alert valign-children-middle">
      <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
          <i class="icon-badgealert"></i>
      </div>
      <div id="error-message-container">
          <h2 tabindex="-1" id="error-heading">Error</h2>
          <p id="error-message">{{errorMessage}}</p>
      </div>
  </div>
  <div class="flex-container" id="flex-container-spinner" *ngIf="submitting">
      <div class="flex-item" id="flex-item-spinner">
          <img class="submitting" src="assets/img/spinner.svg" alt="submitting" id="spinner-image" />
      </div>
  </div>
  <!-- displaying success message -->
  <div *ngIf="formSuccess" id="success-main-container">
      <div class="container-box" id="success-container">
          <div class="alert valign-children-middle" id="alert-success-container">
              <div class="alert-success">
                  <i class="icon-approval" aria-hidden="true"></i>
              </div>
              <div id="success-message-container">
                  <h2 tabindex="-1" id="success-heading">Success</h2>
                  <p id="success-message">{{successMessage}}</p>
              </div>
          </div>
      </div>
  </div>
   
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-6 ">
        <h1>{{dmpWhitelistFansData.dmpfanHeading}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 ">
        <h4 class="dmpfanSubHeading">{{dmpWhitelistFansData.dmpfanSubHeading}}{{":"}}</h4>
        <p class ="dmpfancontent">{{dmpWhitelistFansData.dmpfancontent}}</p>
      </div>
    </div>  

    <div class="row">
      <input id="fanEntryInput" type="text" class="fanEntryInput" [(ngModel)]="inputSlot"
      placeholder="{{dmpWhitelistFansData.inputPlaceholder}}"
      (keyup)="keyValidation($event)" />

      <div class="tooltip-container">
        <i class="icon-flat-faq tooltip-icon" tabindex="0"></i>
        <div class="helper-text" role="tooltip" id="trans">
          <p>{{dmpWhitelistFansData.tooltip}}</p>
        </div>
      </div>

      <div class="col-xs-12 col-sm-3 col-md-3 ">
        <button  type="button" (click)="submitRequest()"  [disabled]="isDisabled" id ="save-button" class="btn btn-secondary save-button">
          {{dmpWhitelistFansData.saveButton}}
        </button>
      </div> 
    </div>

    <div class="row text-danger" *ngIf="setupError">{{dmpWhitelistFansData.inputErrorMsg}}</div>

    <ag-grid-angular
    style="width: 20%; height: 210px;"
    class="ag-theme-alpine"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [animateRows]="true"

    (gridReady)="onGridReady($event)"
    ></ag-grid-angular>

 </div>

</main>